import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'quote-step8',
  templateUrl: 'quote-step8.component.html',
  styleUrls: ['quote-step8.component.css'],
})
export class QuoteStep8Component {
  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();
  
  constructor() {}

  nextStep(): void {
    this.onNextStep.emit(this.currentStep);
  }

  prevStep(): void {
    this.onPrevStep.emit(this.currentStep);
  }
}
